import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          position: "fixed", inset: 0, background: "#0f1117",
          display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", gap: 16, padding: 24,
          fontFamily: "'Helvetica Neue', Arial, sans-serif",
        }}>
          <div style={{ fontSize: 13, color: "#ccc", letterSpacing: "0.04em" }}>
            Something went wrong
          </div>
          <div style={{
            fontSize: 10, color: "#555", fontFamily: "'IBM Plex Mono', monospace",
            maxWidth: 480, textAlign: "center", letterSpacing: "0.04em", lineHeight: 1.6,
          }}>
            {this.state.error.message}
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8, padding: "10px 24px", background: "transparent",
              border: "1px solid #444", borderRadius: 4, color: "#888",
              fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase",
              cursor: "pointer",
            }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
